export default "__VITE_ASSET__D9B6jRLR__"